<template>
    <VueNotification
        ref="vueNotification"
        classes="Notification"
        :group="group"
        :position="position"
        :duration="duration"
        :speed="speed"
        :max="max"
        :reverse="reverse"
        :width="width"
    >
        <template #body="{ item = {} }">
            <div
                class="vue-notification-template Notification"
                :class="[item.type]"
            >
                <div
                    v-if="item.title"
                    class="notification-title"
                >
                    {{ item.title }}
                </div>
                <div
                    v-if="item.text"
                    class="notification-content"
                    v-html="item.text"
                />

                <template v-if="(item.data || {}).link">
                    <WLink
                        class="notification-link"
                        @click="item.data.link.onClick"
                    >
                        {{ item.data.link.text }}
                    </WLink>
                </template>

                <slot v-bind="item" />
            </div>
        </template>
    </VueNotification>
</template>

<script>
/* eslint-disable vue/no-v-html */
import VueTypes from 'vue-types'

export default {
    name: 'NotificationLink',
    props: {
        width: VueTypes.number.def(420),
        group: VueTypes.string.def(() => undefined),
        position: VueTypes.string.def('bottom right'),
        duration: VueTypes.number.def(() => undefined),
        speed: VueTypes.number.def(() => undefined),
        max: VueTypes.number.def(() => 10),
        reverse: VueTypes.bool.def(false),
    },
}
</script>

<style lang="scss">
.notification-wrapper {
    padding: 5px 7.5px !important;
    overflow: unset !important;
}
.Notification {
    margin: 15px;
    padding: 15px;
    border-radius: $border-radius;
    box-shadow: 0 3px 7px 0 rgba($black, 0.2);
    background: $gray-01;
    color: $white;
    font-family: $font-family-sans-serif;
    font-size: $font-size;
    line-height: $font-size + 2;
    .notification-title {
        margin-bottom: 10px;
        font-family: $headings-font-family;
        font-weight: $headings-font-weight;
    }
    .notification-link {
        margin-top: 10px;
        font-size: 16px;
        font-weight: 700;
    }
    &.success {
        color: $success;
        background: lighten($success, 35%);

        .notification-link {
            color: $success;
        }
    }
    &.info {
        color: $info;
        background: lighten($info, 35%);

        .notification-link {
            color: $info;
        }
    }
    &.warning {
        color: $warning;
        background: lighten($warning, 35%);

        .notification-link {
            color: $warning;
        }
    }
    &.error {
        color: $danger;
        background: lighten($danger, 30%);

        .notification-link {
            color: $danger;
        }
    }
}

.FieldErrors {
    margin: 15px 15px 0 15px;
    padding: 0 15px;
    list-style: initial !important;

    &Item {
        margin-bottom: 5px;
    }
}
</style>
